import { HTTP } from '../http.js'

export default {
    getAll(store_id, filter_archived) {
        const query = `?archived=${filter_archived ? 1 : 0}`;

        return HTTP.get(`/tradera_stores/${store_id}/orders${query}`);
    },

    get(store_id, id) {
        return HTTP.get(`/tradera_stores/${store_id}/orders/${id}`);
    },

    put(store_id, id, order) {
        return HTTP.put(`/tradera_stores/${store_id}/orders/${id}`, order);
    },

    printWaybill(store_id, id) {
        return HTTP.post(`/tradera_stores/${store_id}/orders/${id}/print_waybill`);
    },

    archive(store_id, id) {
        return HTTP.post(`/tradera_stores/${store_id}/orders/${id}/archive`);
    }
};
